import { SvelteComponent, init, safe_not_equal, element, attr, toggle_class, insert, action_destroyer, transition_in, transition_out, detach, noop, space, empty, src_url_equal, append, text, set_data, create_component, mount_component, listen, group_outros, check_outros, create_out_transition, destroy_component, onMount, HtmlTag } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { fade } from '../../external_node_modules/svelte/transition/index.mjs.js';
import { updateBrowserControlState } from '../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import { isIngame } from '../../external_node_modules/@wg/web2clientapi/utils/checkIngame.js';
import { playExchangeSound, playButtonClickSound } from '../../external_node_modules/@wg/web2clientapi/sound/index.js';
import { t } from '../../i18n.js';
import { disableBodyOverflow } from '../../utils/disableBodyOverflow.js';
import { setPurchaseResult } from '../../store/purchaseResult.js';
import Button from '../shared/components/Button/Button.svelte.js';
import EscButton from '../shared/components/EscButton/EscButton.svelte.js';
import Warning from './Warning.svelte.js';
import settings from '../../settings.js';
import { handleExternalLink } from '../../utils/externalLink.js';
import getPurchaseErrorCodeText from '../../utils/errorsText.js';
import { PURCHASE_ERROR_CODES } from '../../constants/purchaseErrorCodes.js';
import { openUrl } from '../../utils/openUrl.js';
import './PurchaseResult.css.js';

/* src/ui/PurchaseProduct/PurchaseResult.svelte generated by Svelte v3.44.2 */

function create_if_block_4(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let handleExternalLink_action;
	let current;
	let mounted;
	let dispose;
	const if_block_creators = [create_if_block_5, create_else_block_1];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*isErrorCountryRestriction*/ ctx[3]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "purchase-result__errorMessage wcl-1gnq8fl");
			toggle_class(div, "errorCountryRestrictionMessage", /*isErrorCountryRestriction*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;

			if (!mounted) {
				dispose = action_destroyer(handleExternalLink_action = handleExternalLink.call(null, div));
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if_block.p(ctx, dirty);
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
			mounted = false;
			dispose();
		}
	};
}

// (81:8) {:else}
function create_else_block_1(ctx) {
	let warning;
	let current;

	warning = new Warning({
			props: {
				showIcon: false,
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(warning.$$.fragment);
		},
		m(target, anchor) {
			mount_component(warning, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const warning_changes = {};

			if (dirty & /*$$scope, errorMsg*/ 4098) {
				warning_changes.$$scope = { dirty, ctx };
			}

			warning.$set(warning_changes);
		},
		i(local) {
			if (current) return;
			transition_in(warning.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(warning.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(warning, detaching);
		}
	};
}

// (79:8) {#if isErrorCountryRestriction}
function create_if_block_5(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "class", "wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			div.innerHTML = /*errorMsg*/ ctx[1];
		},
		p(ctx, dirty) {
			if (dirty & /*errorMsg*/ 2) div.innerHTML = /*errorMsg*/ ctx[1];		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (82:10) <Warning showIcon="{false}">
function create_default_slot_3(ctx) {
	let html_tag;
	let html_anchor;

	return {
		c() {
			html_tag = new HtmlTag();
			html_anchor = empty();
			html_tag.a = html_anchor;
		},
		m(target, anchor) {
			html_tag.m(/*errorMsg*/ ctx[1], target, anchor);
			insert(target, html_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*errorMsg*/ 2) html_tag.p(/*errorMsg*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(html_anchor);
			if (detaching) html_tag.d();
		}
	};
}

// (86:4) {#if !purchaseResult.isSuccess && showDefaultSupportMessage}
function create_if_block_3(ctx) {
	let div;
	let raw_value = t('Если ошибка повторяется, вы можете обратиться в {br}{openLink}центр поддержки пользователей{closeLink}.', /*supportMessageData*/ ctx[5]) + "";
	let handleExternalLink_action;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			attr(div, "class", "purchase-result__supportMessage wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			div.innerHTML = raw_value;

			if (!mounted) {
				dispose = action_destroyer(handleExternalLink_action = handleExternalLink.call(null, div));
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (94:4) {#if !isErrorCountryRestriction}
function create_if_block_1(ctx) {
	let div;
	let img;
	let img_src_value;
	let t_1;
	let if_block_anchor;
	let if_block = /*purchaseResult*/ ctx[0].title && create_if_block_2(ctx);

	return {
		c() {
			div = element("div");
			img = element("img");
			t_1 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			if (!src_url_equal(img.src, img_src_value = /*purchaseResult*/ ctx[0].productImageUrl)) attr(img, "src", img_src_value);
			attr(img, "alt", /*title*/ ctx[4]);
			attr(img, "class", "wcl-1gnq8fl");
			toggle_class(img, "failed", !/*purchaseResult*/ ctx[0].isSuccess);
			attr(div, "class", "purchase-result__image wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, img);
			insert(target, t_1, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*purchaseResult*/ 1 && !src_url_equal(img.src, img_src_value = /*purchaseResult*/ ctx[0].productImageUrl)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*purchaseResult*/ 1) {
				toggle_class(img, "failed", !/*purchaseResult*/ ctx[0].isSuccess);
			}

			if (/*purchaseResult*/ ctx[0].title) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t_1);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (98:6) {#if purchaseResult.title}
function create_if_block_2(ctx) {
	let div;
	let t_1_value = /*purchaseResult*/ ctx[0].title + "";
	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(t_1_value);
			attr(div, "class", "purchase-result__name wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*purchaseResult*/ 1 && t_1_value !== (t_1_value = /*purchaseResult*/ ctx[0].title + "")) set_data(t_1, t_1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (116:6) {:else}
function create_else_block(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*closePurchaseResult*/ ctx[6]);

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 4096) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (105:6) {#if isErrorCountryRestriction}
function create_if_block(ctx) {
	let div1;
	let div0;
	let button0;
	let t_1;
	let button1;
	let current;

	button0 = new Button({
			props: {
				outline: true,
				linkTarget: true,
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*click_handler*/ ctx[9]);

	button1 = new Button({
			props: {
				outline: true,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*closePurchaseResult*/ ctx[6]);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			create_component(button0.$$.fragment);
			t_1 = space();
			create_component(button1.$$.fragment);
			attr(div0, "class", "wcl-1gnq8fl");
			attr(div1, "class", "purchase-result__button-line wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(button0, div0, null);
			append(div1, t_1);
			mount_component(button1, div1, null);
			current = true;
		},
		p(ctx, dirty) {
			const button0_changes = {};

			if (dirty & /*$$scope*/ 4096) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);
			const button1_changes = {};

			if (dirty & /*$$scope*/ 4096) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(button0);
			destroy_component(button1);
		}
	};
}

// (117:8) <Button on:click="{closePurchaseResult}">
function create_default_slot_2(ctx) {
	let t_1_value = t('Закрыть') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (108:12) <Button outline="{true}" linkTarget="{true}" on:click="{() => openUrl(settings.urls.userSupportUrl)}">
function create_default_slot_1(ctx) {
	let t_1_value = t('Поддержка') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (112:10) <Button outline="{true}" on:click="{closePurchaseResult}">
function create_default_slot(ctx) {
	let t_1_value = t('Закрыть') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div4;
	let div3;
	let div0;
	let escbutton;
	let t0;
	let div1;
	let t2;
	let t3;
	let t4;
	let t5;
	let div2;
	let current_block_type_index;
	let if_block3;
	let div4_outro;
	let current;
	let mounted;
	let dispose;

	escbutton = new EscButton({
			props: {
				handleClick: /*closePurchaseResult*/ ctx[6]
			}
		});

	let if_block0 = !/*purchaseResult*/ ctx[0].isSuccess && /*errorMsg*/ ctx[1] && create_if_block_4(ctx);
	let if_block1 = !/*purchaseResult*/ ctx[0].isSuccess && /*showDefaultSupportMessage*/ ctx[2] && create_if_block_3(ctx);
	let if_block2 = !/*isErrorCountryRestriction*/ ctx[3] && create_if_block_1(ctx);
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*isErrorCountryRestriction*/ ctx[3]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx);
	if_block3 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div4 = element("div");
			div3 = element("div");
			div0 = element("div");
			create_component(escbutton.$$.fragment);
			t0 = space();
			div1 = element("div");
			div1.textContent = `${/*title*/ ctx[4]}`;
			t2 = space();
			if (if_block0) if_block0.c();
			t3 = space();
			if (if_block1) if_block1.c();
			t4 = space();
			if (if_block2) if_block2.c();
			t5 = space();
			div2 = element("div");
			if_block3.c();
			attr(div0, "class", "purchase-result__close wcl-1gnq8fl");
			attr(div1, "class", "purchase-result__title wcl-1gnq8fl");
			attr(div2, "class", "purchase-result__button wcl-1gnq8fl");
			attr(div3, "class", "purchase-result wcl-1gnq8fl");
			toggle_class(div3, "success", /*purchaseResult*/ ctx[0].isSuccess);
			attr(div4, "class", "purchase-result-overlay wcl-1gnq8fl");
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, div3);
			append(div3, div0);
			mount_component(escbutton, div0, null);
			append(div3, t0);
			append(div3, div1);
			append(div3, t2);
			if (if_block0) if_block0.m(div3, null);
			append(div3, t3);
			if (if_block1) if_block1.m(div3, null);
			append(div3, t4);
			if (if_block2) if_block2.m(div3, null);
			append(div3, t5);
			append(div3, div2);
			if_blocks[current_block_type_index].m(div2, null);
			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!/*purchaseResult*/ ctx[0].isSuccess && /*errorMsg*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*purchaseResult, errorMsg*/ 3) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div3, t3);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (!/*purchaseResult*/ ctx[0].isSuccess && /*showDefaultSupportMessage*/ ctx[2]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_3(ctx);
					if_block1.c();
					if_block1.m(div3, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (!/*isErrorCountryRestriction*/ ctx[3]) if_block2.p(ctx, dirty);
			if_block3.p(ctx, dirty);

			if (dirty & /*purchaseResult*/ 1) {
				toggle_class(div3, "success", /*purchaseResult*/ ctx[0].isSuccess);
			}
		},
		i(local) {
			if (current) return;
			transition_in(escbutton.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block3);
			if (div4_outro) div4_outro.end(1);
			current = true;
		},
		o(local) {
			transition_out(escbutton.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block3);
			div4_outro = create_out_transition(div4, fade, { duration: 150 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div4);
			destroy_component(escbutton);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if_blocks[current_block_type_index].d();
			if (detaching && div4_outro) div4_outro.end();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { closeApplication } = $$props;
	let { purchaseResult } = $$props;
	const errorCode = purchaseResult.errorCode;
	const isErrorCountryRestriction = errorCode === PURCHASE_ERROR_CODES.PURCHASE_FORBIDDEN_BY_COUNTRY_RESTRICTION || errorCode === PURCHASE_ERROR_CODES.PURCHASER_BANNED_BY_SANCTION_RESTRICTION;
	const isErrorProfileCompletion = errorCode === PURCHASE_ERROR_CODES.USER_PROFILE_NOT_COMPLETED;

	const title = purchaseResult.isSuccess
	? t('Покупка прошла успешно!')
	: isErrorCountryRestriction
		? t('Ошибка')
		: t('Произошла ошибка. Повторите попытку позже.');

	const supportMessageData = {
		openLink: settings.userSupportUrl
		? `<a class="external-link" target="_blank" href="${settings.userSupportUrl}">`
		: ``,
		closeLink: settings.userSupportUrl ? `</a>` : ``,
		br: '<br>'
	};

	let errorMsg = null;
	let showDefaultSupportMessage = true;

	if (errorCode) {
		errorMsg = getPurchaseErrorCodeText(errorCode, settings.realm === 'ru');

		if (isErrorCountryRestriction || isErrorProfileCompletion) {
			errorMsg = errorMsg.replace('{link-open}', '').replace('{link-close}', '');
			showDefaultSupportMessage = false;
		}
	}

	onMount(() => {
		if (purchaseResult.isSuccess && isIngame()) {
			playExchangeSound();
		}
	});

	function closePurchaseResult() {
		if (isIngame()) {
			playButtonClickSound();
		}

		setPurchaseResult(null);
		closeApplication();
	}

	function handleKeydown(e) {
		if (e.key === 'Escape') {
			closePurchaseResult();
		}
	}

	disableBodyOverflow(true);
	updateBrowserControlState(true);
	const click_handler = () => openUrl(settings.urls.userSupportUrl);

	$$self.$$set = $$props => {
		if ('closeApplication' in $$props) $$invalidate(8, closeApplication = $$props.closeApplication);
		if ('purchaseResult' in $$props) $$invalidate(0, purchaseResult = $$props.purchaseResult);
	};

	return [
		purchaseResult,
		errorMsg,
		showDefaultSupportMessage,
		isErrorCountryRestriction,
		title,
		supportMessageData,
		closePurchaseResult,
		handleKeydown,
		closeApplication,
		click_handler
	];
}

class PurchaseResult extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { closeApplication: 8, purchaseResult: 0 });
	}
}

export { PurchaseResult as default };
//# sourceMappingURL=PurchaseResult.svelte.js.map
